export default __webpack_public_path__ + "static/media/1.ef086a92.mp4";